class ActivatePopup extends HTMLElement {
  connectedCallback() {
    const appKey = this.dataset.appKey || '';
    const host = this.dataset.host || '';
    const designMode = this.dataset.designMode === 'true';

    function scheduleInit() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(initPopup, { timeout: 4000 });
      } else {
        window.setTimeout(initPopup, 4000);
      }
    }

    function initPopup() {
      fetch('https://app.zalify.com/api/popup?app_key=' + appKey)
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to load popup config');
          return response.json();
        })
        .then(function (data) {
          var plan = data && data.data && data.data.workspace && data.data.workspace.plan;
          var activatePopup = document.getElementById('activate-popup');

          if (plan) {
            document.documentElement.dispatchEvent(
              new CustomEvent('zalify:plan', {
                bubbles: true,
                detail: { type: plan.type },
              })
            );
          }

          if ((!plan || plan.type === 'FREE') && activatePopup) {
            activatePopup.style.display = 'block';
            return;
          }

          if (designMode && data && data.data && data.data.crispWebsiteId && !window.$crisp) {
            window.$crisp = [];
            window.CRISP_WEBSITE_ID = data.data.crispWebsiteId;
            var script = document.createElement('script');
            script.src = 'https://client.crisp.chat/l.js';
            script.async = true;
            document.head.appendChild(script);
            window.$crisp.push([
              'set',
              'session:data',
              ['workspace_slug', 'shopify-' + appKey],
            ]);
          }
        })
        .catch(function () {});
    }

    if (document.readyState === 'complete') {
      scheduleInit();
    } else {
      window.addEventListener('load', scheduleInit, { once: true });
    }
  }
}

customElements.define('activate-popup', ActivatePopup);
